<template>
  <div class='editable-cell'>
    <div v-if="editable" class='editable-cell-input-wrapper'>
      <a-input
        v-model="count"
        ref="input"
        @pressEnter="check"
        style="width: 80px; margin-right: 10px;"
      /><a-icon
      type='check'
      class='editable-cell-icon-check'
      @click="check"
    />
    </div>
    <div v-else>
      {{ used + '/' + count }}
      <a-icon type='edit' class='editable-cell-icon' @click="edit"/>
    </div>
  </div>
</template>

<script>
import '../config/global'
const axios = require('axios')
export default {
  props: ['chatroom_used', 'chatroom_count', 'client_id'],
  name: 'EditableCellChatroomNum',
  data () {
    return {
      editChatroomCountUrlPostFix: 'UClient/edit_chatroom_count',
      used: this.chatroom_used,
      count: this.chatroom_count,
      editable: false
    }
  },
  watch: {
    chatroom_used: function (newValue, oldValue) {
      // console.log('used', newValue, oldValue)
      this.used = newValue
    },
    chatroom_count: function (newValue, oldValue) {
      // console.log('count', newValue, oldValue)
      this.count = newValue
    },
    count: function (newValue, oldValue) {
      // console.log('count', newValue, oldValue)
      var a = parseInt(newValue)
      // console.log('count', a)
      if (isNaN(a) || a < 0) {
        a = 0
      }
      this.count = a
    }
  },
  computed: {
    editChatroomCountUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.editChatroomCountUrlPostFix
    }
  },
  methods: {
    check () {
      // console.log('check')
      // console.log('check value first', this.count)
      axios.post(this.editChatroomCountUrl, {
        client_id: this.client_id,
        chatroom_count: parseInt(this.count),
        token: sessionStorage.token
      }).then((data) => {
        console.log('data.err_code:', data.data.err_code)
        if (data.data.err_code === 0) {
          console.log('check value', this.count)
          this.editable = false
          // this.$emit('change', this.value, this.chatroomname, this.dataIndex)
          // console.log('check promise text', this.text)
        } else if (data.data.err_code === 50002) {
          console.log('token 不对，跳转登录')
          this.$router.push('/')
        }
      })
    },
    edit () {
      this.editable = true
      this.$nextTick(function () {
        this.$refs.input.focus()
      })
    }
  }
}
</script>

<style scoped>

</style>
